<!-- START CONTENT -->
<!-- START SEARCH CRITERIA -->
<div class="col-xs-12">
  <section class="box ">
    <header class="panel_header">
      <h2 class="title pull-left">Request search</h2>
      <div class="actions panel_actions pull-right">
        <a class="box_toggle fa fa-chevron-down" (click)="IsHidden=!IsHidden"></a>
      </div>
    </header>
    <form class="form-horizontal" [formGroup]="filterForm" (ngSubmit)="filterTestRequests(filterForm.value)" autocomplete="off">
      @if(!IsHidden) {
        <div class="content-body">
          <div class="row">
            <div class="col-md-8 col-sm-9 col-xs-10">
              <div class="form-group">
                <label class="form-label">From date</label>
                <div class="controls">
                  <input type="date" class="form-control" formControlName="fromDate" name="fromDate" />
                </div>
              </div>

              <div class="form-group">
                <label class="form-label">To date</label>
                <div class="controls">
                  <input type="date" class="form-control" formControlName="toDate" name="toDate">
                </div>
              </div>

              <div class="form-group">
                <label class="form-label" for="field-1">Forename</label>
                <div class="controls">
                  <input type="text" class="form-control" formControlName="forename" name="forename" />
                </div>
              </div>
              <div class="form-group">
                <label class="form-label" for="field-2">Surname</label>
                <div class="controls">
                  <input type="text" class="form-control" formControlName="surname" name="surname" />
                </div>
              </div>
              <div class="form-group">
                <label class="form-label" for="field-3">DOB</label>
                <div class="controls">
                  <input type="date" class="form-control" formControlName="dob" name="dob" />
                </div>
              </div>
              <div class="form-group">
                <label class="form-label" for="field-4">Email</label>
                <div class="controls">
                  <input type="text" class="form-control" formControlName="email" name="email" />
                </div>
              </div>
              <div class="form-group">
                <label class="form-label" for="field-5">Reference:</label>
                <div class="controls">
                  <input type="text" class="form-control" formControlName="reference" name="reference" />
                </div>
              </div>
              <!-- START SEARCH SUBMIT BUTTONS -->
              <div class="pull-left">
                <button type="submit" class="btn btn-success">Search</button>
                <button type="button" class="btn">Cancel</button>
              </div>

              <!-- END SEARCH SUBMIT BUTTONS -->

            </div>
          </div>

        </div>
      }
    </form>
  </section>
</div>
<!-- END SEARCH CRITERIA -->
